import { translationKey } from '../i18n';
import { localize } from '../i18n';
import SingleLineText from '../components/ui/InternationalText';
import Button from '../components/ui/FitButton';
import LoadingLabel from '../components/LoadingLabel';
import React from 'react';
import { Box, Typography } from '@mui/material';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
import EditNoteIcon from '@mui/icons-material/EditNote';
import InsightsIcon from '@mui/icons-material/Insights';
import PageHeader from '../components/PageHeader';
import useMedicationAddGate from '../hooks/useMedicationAddGate';

const FEATURES = [
    {
        icon: NotificationsOffIcon,
        title: translationKey('알림은 안 가요'),
        desc: translationKey('정해진 시간이 없는 약이니까요'),
    },
    {
        icon: EditNoteIcon,
        title: translationKey('먹을 때마다 한 번만 누르면 끝'),
        desc: translationKey('복용 시간이 자동으로 기록돼요'),
    },
    {
        icon: InsightsIcon,
        title: translationKey('며칠에 몇 번 먹었는지 보여드려요'),
        desc: translationKey('이 약을 얼마나 자주 먹는지 한눈에 확인'),
    },
];

export default function PrnOnboardingPage() {
    const { openMedicationAdd, MedicationAddGateDialog, checkingMedicationLimit } = useMedicationAddGate();

    return (
        <Box sx={{ pb: '120px', bgcolor: '#fff', minHeight: '100vh' }}>
            <PageHeader back title="" />

            <Box sx={{ px: 3, pt: 4 }}>
                <Box
                    sx={{
                        width: 80, height: 80, borderRadius: '20px',
                        bgcolor: '#e0f2fe',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        mb: 3,
                    }}
                >
                    <TouchAppIcon sx={{ fontSize: 44, color: '#38bdf8' }} />
                </Box>

                <Typography sx={{ fontSize: '1.55rem', fontWeight: 800, color: '#1a1a1a', lineHeight: 1.3, mb: 1.5, letterSpacing: '-0.02em' }}>{localize("필요할 때만 먹는 약,")}<br />{localize("이렇게 기록해요")}</Typography>
                <Typography sx={{ fontSize: '1rem', color: '#777', lineHeight: 1.55, mb: 4 }}>{localize("두통약·소화제·알레르기 약처럼")}<br />{localize("매일 정해놓고 먹지 않는 약을 위한 기능이에요")}</Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.2, mb: 4 }}>
                    {FEATURES.map((f, i) => {
                        const Icon = f.icon;
                        return (
                            <Box
                                key={i}
                                sx={{
                                    display: 'flex', alignItems: 'flex-start', gap: 1.5,
                                    p: 1.8, bgcolor: '#f8fafc', borderRadius: '14px',
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 40, height: 40, borderRadius: '10px',
                                        bgcolor: '#e0f2fe', flexShrink: 0,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    }}
                                >
                                    <Icon sx={{ fontSize: 22, color: '#38bdf8' }} />
                                </Box>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                    <SingleLineText sx={{ fontSize: '1rem', fontWeight: 700, color: '#1a1a1a', mb: '2px' }}>
                                        {localize(f.title)}
                                    </SingleLineText>
                                    <SingleLineText sx={{ fontSize: '0.9rem', color: '#888', lineHeight: 1.4 }}>
                                        {localize(f.desc)}
                                    </SingleLineText>
                                </Box>
                            </Box>
                        );
                    })}
                </Box>
            </Box>

            <Box
                sx={{
                    position: 'fixed', left: 0, right: 0, bottom: 0,
                    px: 2, py: 1.5, bgcolor: '#fff',
                    borderTop: '1px solid #f0f0f0',
                }}
            >
                <Button
                    variant="contained"
                    fullWidth
                    disabled={checkingMedicationLimit}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => openMedicationAdd('/medications/new-bundle?mode=manual&frequency=AS_NEEDED', { replace: true })}
                    sx={{
                        bgcolor: '#ffe566', color: '#5a4a00',
                        '&:hover': { bgcolor: '#e8d040' },
                        borderRadius: 3, py: 1.7, fontSize: '1.05rem', fontWeight: 700,
                    }}
                >
                    {checkingMedicationLimit ? <LoadingLabel /> : localize("약 추가하기")}
                </Button>
            </Box>
            <MedicationAddGateDialog />
        </Box>
    );
}
